import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import { Code } from "./Code";

export interface HashProps {
	value: string;
	length?: number;
	prefix?: boolean;
	className?: string;
	action?: ReactNode;
}

function truncateHash(
	value: string,
	length: number,
	keepPrefix: boolean,
): string {
	const stripped = value.startsWith("0x") ? value.slice(2) : value;
	const fullHex = value.startsWith("0x") ? stripped : value;

	if (fullHex.length <= length * 2) {
		return keepPrefix && value.startsWith("0x") ? value : fullHex;
	}

	const start = fullHex.slice(0, length);
	const end = fullHex.slice(-length);
	const pre = keepPrefix && value.startsWith("0x") ? "0x" : "";
	return `${pre}${start}...${end}`;
}

function Hash({
	value,
	length = 6,
	prefix = true,
	className,
	action,
}: HashProps): ReactNode {
	const truncated = truncateHash(value, length, prefix);

	return (
		<span className={cn("inline-flex items-center gap-1", className)}>
			<Code className="font-mono text-xs">{truncated}</Code>
			{action}
		</span>
	);
}
Hash.displayName = "Hash";

export default Hash;
export { Hash };
